module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"proposal":{"title":"Заявки на демо-доступ"}},"en":{"proposal":{"title":"Demo-access proposals"}}}')
  delete Component.options._Ctor
}
